import { useState } from 'react';
import { useResizeObserver } from '@react-hookz/web';
import type { ChatWindow } from '@erp/rpc';

/**
 * The size of the chat transcript the user last saw, sent with each message
 * so the assistant fits the views it shows (`show_view`) to it. The docked
 * panel is resizable and the home chat is a full page, so it is measured, not
 * assumed. With more than one transcript mounted, the last one resized wins.
 */
let latest: ChatWindow | undefined;

export function currentChatWindow(): ChatWindow | undefined {
  return latest;
}

/** Records a transcript's size: its content width and its viewport height. */
export function reportChatWindow(width: number, height: number): void {
  if (width < 1 || height < 1) return;
  latest = { width: Math.round(width), height: Math.round(height) };
}

/** A ref for the transcript's content node that keeps its size reported. */
export function useChatWindowReporter(): (node: HTMLElement | null) => void {
  const [node, setNode] = useState<HTMLElement | null>(null);
  const viewport =
    node?.closest<HTMLElement>('[data-slot="scroll-area-viewport"]') ?? null;
  const report = () => {
    if (!node) return;
    reportChatWindow(
      node.clientWidth,
      viewport?.clientHeight ?? window.innerHeight,
    );
  };
  useResizeObserver(node, report);
  useResizeObserver(viewport, report);
  return setNode;
}
